export default __webpack_public_path__ + "static/media/AMS.7ad88f2e.png";